import { useLocation } from "react-router-dom";

const hostname_local = typeof window !== "undefined" ? window.location.hostname : "";
const isKnownProd = hostname_local.includes("conexopos.com");
const SAAS_ROOT = isKnownProd ? "conexopos.com" : (process.env.REACT_APP_SAAS_ROOT || "sass.local");

export function resolveHostContext(hostname, pathname, search) {
    const isKnownProd = hostname.includes("conexopos.com");
    const SAAS_ROOT = isKnownProd ? "conexopos.com" : (process.env.REACT_APP_SAAS_ROOT || "sass.local");
    
    console.log(`[HostContext] Solving for: ${hostname}${pathname}${search}`);

    const isDevHost = hostname === "localhost" || hostname === "127.0.0.1" || hostname === "0.0.0.0";
    const isVercel = hostname.endsWith(".vercel.app");
    const isRootDomain = hostname === SAAS_ROOT || hostname === `www.${SAAS_ROOT}`;

    if (hostname.includes("pedido.")) {
        const pathParts = pathname.split('/').filter(Boolean);
        const GLOBAL_HUB_ROUTES = ["auth", "driver", "staff", "superadmin", "pedidos-local", "demo", "google"];
        
        if (pathParts.length > 0 && !GLOBAL_HUB_ROUTES.includes(pathParts[0])) {
            const ctx = { context: "tenant", subdomain: pathParts[0], isHub: true, hubPrefix: `/${pathParts[0]}` };
            console.log("[HostContext] Hub tenant resolved:", ctx.subdomain);
            return ctx;
        }
    }

    // ── QUERY PARAM OVERRIDE (For testing/demo)
    const params = new URLSearchParams(search);
    const tenantParam = params.get("tenant");
    if (tenantParam) {
        return { context: "tenant", subdomain: tenantParam };
    }

    // ── 1. Shell Context: conexopos.com (y www) o vercel root ──────────────────
    // Si hay una sesión demo activa de forma explícita, forzamos tenant
    const demoMode = typeof sessionStorage !== "undefined" ? sessionStorage.getItem("demo_mode") : null;
    if (demoMode === "true") {
        return { context: "tenant", subdomain: "demo" };
    }

    // Si es el dominio raíz o el despliegue de Vercel (sin subdominio de tenant)
    if (isRootDomain || (isVercel && !hostname.split(".")[0].includes("-"))) {
        return { context: "shell", subdomain: null };
    }

    // ── 2. Tenant Context: {sub}.conexopos.com ──────────────────────────────────
    if (hostname.endsWith(`.${SAAS_ROOT}`)) {
        const parts = hostname.replace(`.${SAAS_ROOT}`, "").split(".");
        const subdomain = parts[parts.length - 1]; // El más cercano al dominio raíz
        
        if (subdomain !== "www") {
            return { context: "tenant", subdomain };
        }
    }

    // ── 3. localhost / 127.0.0.1 → Usar sessionStorage ───────────
    if (isDevHost) {
        const devMode = typeof sessionStorage !== "undefined" ? sessionStorage.getItem("dev_mode") : null;
        if (devMode === "shell") return { context: "shell", subdomain: null };
        if (devMode === "tenant") {
            return {
                context: "tenant",
                subdomain: (typeof sessionStorage !== "undefined" ? sessionStorage.getItem("dev_subdomain") : null) || "demo",
            };
        }
        return { context: "dev", subdomain: null };
    }

    // ── 4. Cualquier otro host en producción propia → Tenant ──────
    return { context: "tenant", subdomain: hostname.split(".")[0] };
}

export function useHostContext() {
    // We MUST use window.location directly because resolveHostContext 
    // needs the RAW path to detect the tenant correctly in Hub mode.
    // React Router's location.pathname is already stripped of the basename.
    return resolveHostContext(window.location.hostname, window.location.pathname, window.location.search);
}
